import { DateneingabeFahrzeug } from '../DateneingabeFahrzeug';
import { formStyle } from '../../../core/forms/WFormFramework';
import * as React from 'react';
import { StandorteFahrzeugeJahreswerte } from './StandorteFahrzeugeJahreswerte';

interface FahrzeugeDetailProps extends React.ClassAttributes<any> {
    data: any;
    fahrzeugSelected: any;
}

export class FahrzeugeDetail extends React.Component<FahrzeugeDetailProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        const styleHinweis: React.CSSProperties = { fontSize: '11pt', fontStyle: 'italic', marginLeft: 10, padding: '0 18px 0 22px' };
        const styleTitel: React.CSSProperties = {
            fontSize: '14pt', fontWeight: 'bold', color: '#5e5e5e', backgroundColor: '#bccae3', padding: '0 10px'
        };
        const symbol: React.ReactElement = <span style={{ fontSize: '16pt', fontStyle: 'normal', marginLeft: -25 }}>&#x21e8;&nbsp;</span>;

        return (
            <div style={{ minWidth: 1200, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                <div style={styleTitel}>
                    Fahrzeug: {this.props.fahrzeugSelected.name}
                </div>
                <div style={styleHinweis}>
                    {symbol}Bitte erfassen Sie hier zunächst die nicht veränderlichen <b>„Stammdaten“</b> des Fahrzeugs
                </div>
                <div style={styleHinweis}>
                    {symbol}
                    Laufleistung und Nutzung etc. ändern sich von Jahr zu Jahr.
                    Bitte prüfen und hinterlegen Sie diese Daten daher jährlich bei den <b>„Jahresdaten“</b>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', minHeight: 0 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        {this.renderTitel('Stammdaten bearbeiten')}
                        <div style={{ height: 12, borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>&nbsp;</div>
                        <div style={{ borderRight: '1px solid rgba(0, 0, 0, 0.1)', overflowY: 'scroll' }}>
                            <DateneingabeFahrzeug
                                data={this.props.data}
                                fahrzeugSelected={this.props.fahrzeugSelected}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        {this.renderTitel('Jahresdaten ergänzen')}
                        <div style={{ height: 12 }}>&nbsp;</div>
                        <div style={{ overflowY: 'auto' }}>
                            <StandorteFahrzeugeJahreswerte
                                fahrzeugSelected={this.props.fahrzeugSelected}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderTitel(text: React.ReactElement | string): JSX.Element {
        return (
            <div className={formStyle.flowV2}>
                <div className={formStyle.titel} style={{ width: 'unset', marginLeft: 'unset' }}>
                    <div style={{ padding: '18px 12px 12px 0' }}>{text}</div>
                </div>
            </div>
        );
    }
}
